import {
  createElementVNode as _createElementVNode,
  openBlock as _openBlock,
  createElementBlock as _createElementBlock,
} from "vue";

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
      },
      [
        _createElementVNode("path", {
          d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM11.7678 6.11092C12.1583 5.72039 12.7915 5.72039 13.182 6.11092L13.8891 6.81803C14.2796 7.20855 14.2796 7.84171 13.8891 8.23224L12.1213 10L13.8891 11.7678C14.2796 12.1583 14.2796 12.7915 13.8891 13.182L13.182 13.8891C12.7914 14.2796 12.1583 14.2796 11.7678 13.8891L10 12.1213L8.23224 13.8891C7.84171 14.2796 7.20856 14.2796 6.81802 13.8891L6.11093 13.182C5.7204 12.7915 5.7204 12.1583 6.11093 11.7678L7.87869 10L6.1109 8.23224C5.7204 7.84171 5.7204 7.20855 6.1109 6.81803L6.81802 6.11092C7.20853 5.72039 7.84171 5.72039 8.23224 6.11092L10 7.87869L11.7678 6.11092Z",
          "clip-rule": "evenodd",
          "fill-rule": "evenodd",
        }),
      ],
    )
  );
}
